module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.5085/img/callout-wave.svg"